import * as React from 'react'
import { useEntity } from '@uswitch/ev-utils/lib/context/selectors'
import { stylePath } from './index'
import RichTextBlock from '../rich-text'

const SingleReviewItem = ({ authorImage, authorName, review, reviewerLocation }) => {
  const image = useEntity(authorImage)

  return (
    <div sx={{ variant: stylePath('wrapperSingle') }}>
      <div sx={{ variant: stylePath('reviewQuoteContainer') }}>
        <RichTextBlock content={review} style={{ variant: stylePath('reviewQuote') }} />
      </div>
      <div sx={{ variant: stylePath('authorItem') }}>
        {image.file && (
          <img sx={{ variant: stylePath('authorImage') }} alt={authorName} src={image.file.url} />
        )}
        <div style={{ textAlign: 'left', marginLeft: 10 }}>
          <b sx={{ variant: stylePath('authorName') }}>—{authorName}</b>

          {/* the location is being used as the date: */}
          <div sx={{ variant: stylePath('reviewerLocation') }}>{reviewerLocation}</div>
        </div>
      </div>
    </div>
  )
}

const SingleReview = ({ heading, child }) => {
  const childEntity = useEntity(child)

  return <SingleReviewItem heading={heading} {...childEntity} />
}

export default SingleReview
